import { ReactComponent as SwapIconSvg } from './icons/pools.svg'

export function PoolsIcon(props: { className?: string }) {
    return <SwapIconSvg className={`${props.className}`} />
}
